import { template } from 'lodash-es';

interface ITemplateExecutor {
    (data?: object): string;
    source: string;
}

interface IFormatCache {
    [key: string]: ITemplateExecutor
}

export default class BaseFormatter {
    _caches: IFormatCache = {};

    constructor() {
        this._caches = {};
    }

    interpolate(message: string, values?: any): string {
        if (!values) {
            return message;
        }

        if (!this._caches.hasOwnProperty(message)) {
            this._caches[message] = template(message, {
                interpolate: /{{([\s\S]+?)}}/g,
            });
        }

        return this._caches[message](values);
    }
}
